import { FC } from 'react';
import { useIsFrontendStyleRed } from '@edikk-edikk/country-frontend';
import homeBackgroundCss from './assets/home-background.module.scss';

const BackgroundGradient: FC = () => {
  const isFrontendStyleRed = useIsFrontendStyleRed();

  if (!isFrontendStyleRed) {
    return null;
  }

  return <div className={homeBackgroundCss.homeBackground__gradient} />;
};

export { BackgroundGradient };
